<template>
  <div class="benefit-card" :class="customClass" :style="animationStyle">
    <div class="benefit-icon" v-if="icon">
      <i :class="icon"></i>
    </div>
    <h4 class="benefit-title" v-if="title">{{ title }}</h4>
    <p class="benefit-text" v-if="text">{{ text }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BenefitCard",
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    animationDelay: {
      type: Number,
      default: 0
    },
    customClass: {
      type: String,
      default: "animate-on-scroll fade-in-up"
    }
  },
  computed: {
    animationStyle() {
      return this.animationDelay > 0 
        ? { 'animation-delay': `${this.animationDelay}s` }
        : {};
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.benefit-card {
  background: linear-gradient(135deg, #ffffff 0%, $landing-bg-light 100%);
  padding: 2.5rem;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 5px 20px $landing-primary-rgba-08;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  border: 1px solid $landing-primary-rgba-15;
  
  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 15px 40px $landing-primary-rgba-25;
    background: linear-gradient(135deg, #ffffff 0%, #E8F4F8 100%);
    border-color: $landing-primary-rgba-30;
    
    .benefit-icon {
      transform: scale(1.1) rotate(5deg);
    }
  }
  
  .benefit-icon {
    width: 80px;
    height: 80px;
    background: $landing-primary-gradient;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    
    i {
      font-size: 2.5rem;
      color: white;
    }
  }
  
  .benefit-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #2D4A4D;
    margin-bottom: 1rem;
  }
  
  .benefit-text {
    color: #2D4A4D;
    line-height: 1.7;
  }
}
</style>
